let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("63HP0")).then(() => parcelRequire('d9V3g'));